<template>
  <v-app>
    <Header/>
    <Sidebar/>
    <v-content>
      <v-container fluid py-2 px-3 style="padding-bottom: 0 !important;">
        <v-layout>
          <v-flex text-xs-left xs12 md3 px-3 v-if="!currentCustomer">
            <v-text-field v-model="search" append-icon="search" placeholder="Search" v-if="!currentCustomer" style="padding-bottom: 0 !important;"></v-text-field>
          </v-flex>
          <v-flex text-xs-left xs12 md3 v-if="currentCustomer">
            <v-btn flat v-if="canPrintShipments" @click="printShipments" class="bw-3">Print</v-btn>
            <v-btn flat v-if="canExportShipments" @click="exportShipments" class="bw-3">Excel</v-btn>
          </v-flex>
          <v-flex text-xs-right xs12 md9>
            <v-btn flat v-if="!currentCustomer" @click="toggleFilterInactive(false)" class="bw-4" :style="buttonStyleFilterActive" :disabled="!filterInactive">Active</v-btn>
            <v-btn flat v-if="!currentCustomer" @click="toggleFilterInactive(true)" class="bw-4" :style="buttonStyleFilterInactive" :disabled="filterInactive" style="margin-right: 50px;">Inactive</v-btn>
            <v-btn flat v-if="!currentCustomer" @click="editNewCustomer" class="bw-6">Create new customer</v-btn>
            <v-btn flat v-if="currentCustomer && !currentDeliveryAddress" :disabled="saveButtonDisabled" @click="saveCustomer" class="bw-3">{{ currentCustomer.id > 0 ? 'Save' : 'Create' }}</v-btn>
            <v-btn flat v-if="currentDeliveryAddress" @click="saveDeliveryAddress" :disabled="saveDeliveryAddressButtonDisabled" class="bw-3">{{ currentDeliveryAddress.id > 0 ? 'Save' : 'Create' }}</v-btn>
            <v-btn flat v-if="currentCustomer && currentCustomer.id > 0 && !currentDeliveryAddress" @click="confirmDeleteDialog = true" class="bw-3">Delete</v-btn>
            <v-btn flat v-if="currentDeliveryAddress && currentDeliveryAddress.id > 0" @click="confirmDeleteDeliveryAddressDialog = true" class="bw-3">Delete</v-btn>
            <v-btn flat v-if="currentCustomer && currentCustomer.id > 0 && !currentDeliveryAddress" @click="addDeliveryAddress" class="bw-6">Add delivery address</v-btn>
            <v-btn flat v-if="currentCustomer && !currentDeliveryAddress" @click="cancelCustomer" class="bw-3">Cancel</v-btn>
            <v-btn flat v-if="currentDeliveryAddress" @click="cancelDeliveryAddress" class="bw-3">Cancel</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid py-2 px-3 v-show="!currentCustomer" >
        <v-layout style="max-height: calc(100vh - 160px);">
          <v-flex text-xs-right style="border: 1px solid #DDDDDD; border-radius: 3px; overflow-y: auto;">
            <v-data-table :headers="headers" :items="filteredCustomers" :search="search" hide-actions>
              <template v-slot:items="props">
                <tr @click="selectCustomer(props.item)" class="selectable">
                  <td class="text-xs-left">{{ props.item.name }}</td>
                  <td class="text-xs-left">{{ props.item.vat }}</td>
                  <td class="text-xs-left" style="white-space: pre-line;">{{ props.item.email }}</td>
                  <td class="text-xs-left">{{ props.item.phone }}</td>
                  <td class="text-xs-left">{{ props.item.mobile }}</td>
                  <td class="text-xs-left">{{ props.item.salesOrganization ? props.item.salesOrganization.name : '' }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>

      <v-container fluid py-0 px-0 v-if="currentCustomer" >
        <v-layout style="max-height: calc(100vh - 160px);">
          <v-flex style="overflow-y: auto;">
            <Panel v-if="currentCustomer && !currentDeliveryAddress">
              <PanelColumn title="Customer">
                <v-flex xs4 md2>
                  <v-label>Name</v-label>
                </v-flex>
                <v-flex xs8 md5>
                  <v-text-field color="teal" v-model="currentCustomer.name" ref="name" autocomplete="offit"></v-text-field>
                </v-flex>
                <v-flex xs0 md1/>
                <v-flex xs4 md2>
                  <v-label>Language</v-label>
                </v-flex>
                <v-flex xs8 md2>
                  <v-select :items="languages" v-model="currentCustomer.locale" item-text="label" item-value="locale"></v-select>
                </v-flex>

                <v-flex xs4 md2>
                  <v-label>E-mails</v-label>
                </v-flex>
                <v-flex xs8 md5>
                  <v-textarea solo auto-grow flat rows="3" maxlength="255" v-model="currentCustomer.email" class="multipleEmails"></v-textarea>
                </v-flex>
                <v-flex xs0 md1/>
                <v-flex xs4 md2>
                  <v-label>VAT no.</v-label>
                </v-flex>
                <v-flex xs8 md2>
                  <v-text-field color="teal" v-model="currentCustomer.vat" style="width: 120px;" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 md2>
                  <v-label>Phone</v-label>
                </v-flex>
                <v-flex xs8 md5>
                  <v-text-field color="teal" v-model="currentCustomer.phone" style="width: 120px;" autocomplete="offit"></v-text-field>
                </v-flex>
                <v-flex xs0 md1/>
                <v-flex xs4 md2>
                  <v-label>Mobile</v-label>
                </v-flex>
                <v-flex xs8 md2>
                  <v-text-field color="teal" v-model="currentCustomer.mobile" style="width: 120px;" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 md2>
                  <v-label>Customer number</v-label>
                </v-flex>
                <v-flex xs8 md5>
                  <v-text-field color="teal" v-model="currentCustomer.customerNumber" type="number" style="width: 120px;" autocomplete="offit"></v-text-field>
                </v-flex>
                <v-flex xs0 md1/>
                <v-flex xs4 md2>
                  <v-label>Inactive</v-label>
                </v-flex>
                <v-flex xs8 md2>
                  <v-checkbox color="teal" v-model="currentCustomer.inactive"/>
                </v-flex>
                <v-flex xs12/>

                <v-flex xs4 md2>
                  <v-label>Sales organization</v-label>
                </v-flex>
                <v-flex xs8 md5>
                  <v-select :items="salesOrganizations" v-model="currentCustomer.salesOrganization" item-text="name" return-object style="max-width: 300px;"></v-select>
                </v-flex>
                <v-flex xs0 md1/>
                <v-flex xs4 md2>
                </v-flex>
                <v-flex xs8 md2>
                </v-flex>

              </PanelColumn>

              <v-flex xs12 px-5 py-3 text-xs-center>
              </v-flex>

              <PanelColumn2 title="Address">
                <v-flex xs4 sm4>
                  <v-label>Street</v-label>
                </v-flex>
                <v-flex xs8 sm8 style="padding-left: 10px;">
                  <v-text-field color="teal" v-model="currentCustomer.address.street" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm4>
                  <v-label>House no.</v-label>
                </v-flex>
                <v-flex xs8 sm8 style="padding-left: 10px;">
                  <v-text-field color="teal" v-model="currentCustomer.address.houseNo" style="width: 75px;" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm4>
                  <v-label>Location</v-label>
                </v-flex>
                <v-flex xs8 sm8 style="padding-left: 10px;">
                  <v-text-field color="teal" v-model="currentCustomer.address.location" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm4>
                  <v-label>Postal code</v-label>
                </v-flex>
                <v-flex xs8 sm8 style="padding-left: 10px;">
                  <v-text-field color="teal" v-model="currentCustomer.address.zipCode" style="width: 100px" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm4>
                  <v-label>City</v-label>
                </v-flex>
                <v-flex xs8 sm8 style="padding-left: 10px;">
                  <v-text-field color="teal" v-model="currentCustomer.address.city" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm4>
                  <v-label>Country</v-label>
                </v-flex>
                <v-flex xs8 sm8 style="padding-left: 10px;">
                  <v-text-field color="teal" v-model="currentCustomer.address.country" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm4>
                  <v-label>Geo code</v-label>
                </v-flex>
                <v-flex xs4 sm4 style="padding-left: 10px;">
                  <v-text-field color="teal" v-model="currentCustomer.address.latitude" autocomplete="offit"></v-text-field>
                </v-flex>
                <v-flex xs4 sm4 style="padding-left: 10px;">
                  <v-text-field color="teal" v-model="currentCustomer.address.longitude" autocomplete="offit"></v-text-field>
                </v-flex>
                <v-flex xs12 text-xs-right>
                  <v-btn @click="$refs.maps.addressToGeo(currentCustomer.address)" flat>Lookup geo code</v-btn>
                </v-flex>
              </PanelColumn2>
              <v-flex xs12 class="hidden-md-and-up" style="height: 25px;"></v-flex>
              <PanelColumn2 style="padding-top: 25px;">
                <Maps v-model="currentCustomer.address" ref="maps" height="285px"/>
              </PanelColumn2>
            </Panel>

            <Panel v-if="currentCustomer && deliveryAddresses.length > 0 && !currentDeliveryAddress">
              <PanelColumn title="Delivery addresses">
                <v-flex style="border: 1px solid #DDDDDD; border-radius: 3px; overflow-y: auto;">
                  <v-data-table :headers="deliveryAddressHeaders" :items="deliveryAddresses" hide-actions class="narrow">
                    <template v-slot:items="props">
                      <tr @click="selectDeliveryAddress(props.item)" class="selectable customerDeliveryAddresses">
                        <td class="text-xs-left">{{ props.item.address.street }}</td>
                        <td class="text-xs-left" style="width: 60px !important;">{{ props.item.address.houseNo }}</td>
                        <td class="text-xs-left" style="width: 200px !important;">{{ props.item.address.location }}</td>
                        <td class="text-xs-left" style="width: 100px !important;">{{ props.item.address.zipCode }}</td>
                        <td class="text-xs-left" style="width: 200px !important;">{{ props.item.address.city }}</td>
                        <td class="text-xs-left" style="width: 150px !important;">{{ props.item.address.country }}</td>
                        <td class="text-xs-left" style="width: 150px !important;">{{ props.item.inactive ? 'Yes' : 'No' }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </PanelColumn>
            </Panel>
            <Panel v-if="currentCustomer && currentDeliveryAddress">
              <PanelColumn2 title="Delivery address">
                <v-flex xs4 sm3>
                  <v-label>Street</v-label>
                </v-flex>
                <v-flex xs8 sm9>
                  <v-text-field color="teal" v-model="currentDeliveryAddress.address.street" ref="deliveryAddressStreet" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm3>
                  <v-label>House no.</v-label>
                </v-flex>
                <v-flex xs8 sm9>
                  <v-text-field color="teal" v-model="currentDeliveryAddress.address.houseNo" style="width: 75px;" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm3>
                  <v-label>Location</v-label>
                </v-flex>
                <v-flex xs8 sm9>
                  <v-text-field color="teal" v-model="currentDeliveryAddress.address.location" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm3>
                  <v-label>Postal code</v-label>
                </v-flex>
                <v-flex xs8 sm9>
                  <v-text-field color="teal" v-model="currentDeliveryAddress.address.zipCode" style="width: 100px" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm3>
                  <v-label>City</v-label>
                </v-flex>
                <v-flex xs8 sm9>
                  <v-text-field color="teal" v-model="currentDeliveryAddress.address.city" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 sm3>
                  <v-label>Country</v-label>
                </v-flex>
                <v-flex xs8 sm9>
                  <v-text-field color="teal" v-model="currentDeliveryAddress.address.country" autocomplete="offit"></v-text-field>
                </v-flex>

                <v-flex xs4 md3>
                  <v-label>Inactive</v-label>
                </v-flex>
                <v-flex xs8 md9>
                  <v-checkbox color="teal" v-model="currentDeliveryAddress.inactive"/>
                </v-flex>

                <v-flex xs4 sm3>
                  <v-label>Geo code</v-label>
                </v-flex>
                <v-flex xs3 sm4>
                  <v-text-field color="teal" v-model="currentDeliveryAddress.address.latitude" autocomplete="offit"></v-text-field>
                </v-flex>
                <v-flex xs2 sm1/>
                <v-flex xs3 sm4>
                  <v-text-field color="teal" v-model="currentDeliveryAddress.address.longitude" autocomplete="offit"></v-text-field>
                </v-flex>
                <v-flex xs12 text-xs-right>
                  <v-btn @click="$refs.maps.addressToGeo(currentDeliveryAddress.address)" flat>Lookup geo code</v-btn>
                </v-flex>
              </PanelColumn2>
              <PanelColumn2 style="padding-top: 25px;">
                <Maps v-model="currentDeliveryAddress.address" ref="maps" height="285px"/>
              </PanelColumn2>
            </Panel>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <Footer/>

    <v-dialog v-model="confirmDeleteDialog" persistent width="350">
      <v-card pa-5>
        <v-card-title class="headline">Delete customer</v-card-title>
        <v-card-text v-if="currentCustomer">Are you sure you want to delete '{{ currentCustomer.name }}'?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="this.deleteCustomer">Yes</v-btn>
          <v-btn flat @click="confirmDeleteDialog = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmDeleteDeliveryAddressDialog" persistent width="400">
      <v-card pa-5>
        <v-card-title class="headline">Delete delivery address</v-card-title>
        <v-card-text>Are you sure you want to delete this delivery address?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="this.deleteDeliveryAddress">Yes</v-btn>
          <v-btn flat @click="confirmDeleteDeliveryAddressDialog = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import Header from '../components/Header'
import Sidebar from '../components/Sidebar'
import Footer from '../components/Footer'
import Panel from '../components/Panel'
import Maps from '../components/Maps'
import PanelColumn from '../components/PanelColumn'
import PanelColumn2 from '../components/PanelColumn2'
import axios from 'axios'
import uuid from 'uuid/v4'
import { mapGetters } from 'vuex'

export default {
  name: 'Customers',
  components: {Header, Sidebar, Footer, Panel, PanelColumn, PanelColumn2, Maps},
  data () {
    return {
      search: '',
      headers: [
        { text: 'Name', value: 'name', sortable: true },
        { text: 'VAT', value: 'vat', sortable: false },
        { text: 'Email', value: 'email', sortable: false },
        { text: 'Phone', value: 'phone', sortable: false },
        { text: 'Mobile', value: 'mobile', sortable: false },
        { text: 'Sales organization', value: 'salesOrganization.name', sortable: true }
      ],
      deliveryAddressHeaders: [
        { text: 'Street', value: 'street', sortable: false },
        { text: 'No.', value: 'houseNo', sortable: false },
        { text: 'Location', value: 'location', sortable: false },
        { text: 'Postal code', value: 'zipCode', sortable: false },
        { text: 'City', value: 'city', sortable: false },
        { text: 'Country', value: 'country', sortable: false },
        { text: 'Inactive', value: 'inactive', sortable: false }
      ],
      languages: [
        { label: 'Danish', locale: 'da' },
        { label: 'English', locale: 'en' },
        { label: 'French', locale: 'fr' },
        { label: 'German', locale: 'de' }
      ],
      customers: [],
      salesOrganizations: [],
      deliveryAddresses: [],
      currentCustomer: null,
      currentDeliveryAddress: null,
      confirmDeleteDialog: false,
      confirmDeleteDeliveryAddressDialog: false,
      filterInactive: false
    }
  },
  created: function () {
    this.$store.dispatch('page/setSidebarItem', { key: 'customers' })
    this.loadCustomers()
    this.loadSalesOrganizations()
  },
  computed: {
    users: function () {
      return this.$store.state.user.users
    },
    saveButtonDisabled: function () {
      return !this.currentCustomer || this.currentCustomer.name.trim() === '' || !this.currentCustomer.salesOrganization
    },
    saveDeliveryAddressButtonDisabled: function () {
      return !this.currentDeliveryAddress || (this.currentDeliveryAddress.address.street.trim() === '' && this.currentDeliveryAddress.address.houseNo.trim() === '' && this.currentDeliveryAddress.address.location.trim() === '' && this.currentDeliveryAddress.address.zipCode.trim() === '' && this.currentDeliveryAddress.address.city.trim() === '' && this.currentDeliveryAddress.address.country.trim() === '' && this.currentDeliveryAddress.address.latitude.trim() === '' && this.currentDeliveryAddress.address.longitude.trim() === '')
    },
    canPrintShipments: function () {
      return this.currentCustomer && this.currentCustomer.id > 0
    },
    canExportShipments: function () {
      return this.currentCustomer && this.currentCustomer.id > 0
    },
    buttonStyleFilterActive () {
      return (this.filterInactive === false ? ' color: #606060 !important;' : '')
    },
    buttonStyleFilterInactive () {
      return (this.filterInactive === true ? ' color: #606060 !important;' : '')
    },
    filteredCustomers () {
      return this.customers.filter(c => this.filterInactive ? c.inactive : !c.inactive)
    },
    allSalesOrganizations: function () {
      return this.$store.getters['app/getSalesOrganizations']
    },
    ...mapGetters({
      sessionSalesOrganizations: 'session/getSalesOrganizations'
    })
  },
  methods: {
    loadCustomers () {
      // console.log('Loading customers')
      axios.get('/backend/rest/customer/all')
        .then(response => {
          // console.log('Response data: ' + Object.keys(response))
          this.customers = response.data
          // console.log('Customers: ' + this.customers)
        })
    },
    selectCustomer (item) {
      this.deliveryAddresses = []
      for (let c of this.customers) {
        if (c.id === item.id) {
          this.currentCustomer = c
          if (this.currentCustomer.address.latitude === 0) {
            this.currentCustomer.address.latitude = ''
          }
          if (this.currentCustomer.address.longitude === 0) {
            this.currentCustomer.address.longitude = ''
          }
          break
        }
      }
      if (!this.currentCustomer.locale || this.currentCustomer.locale === '') {
        this.currentCustomer.locale = 'en'
      }
      // console.log('The current customer is: ' + this.currentCustomer.name)
      this.loadDeliveryAddresses()
    },
    editNewCustomer () {
      // console.log('Create a new customer')
      this.currentCustomer = {
        id: 0,
        name: '',
        vat: '',
        email: '',
        phone: '',
        mobile: '',
        customerNumber: '',
        locale: 'en',
        address: {
          street: '',
          houseNo: '',
          location: '',
          zipCode: '',
          city: '',
          country: '',
          latitude: '',
          longitude: ''
        }
      }
      this.deliveryAddresses = []
      this.$nextTick(() => this.$refs.name.focus())
    },
    saveCustomer () {
      // console.log('Save the customer')
      axios.post('/backend/rest/customer', this.currentCustomer)
        .then(response => {
          // console.log('Got response: ' + response)
          this.loadCustomers()
        })
        .catch(error => {
          console.log(error.response.data.message)
        })
      this.currentCustomer = null
    },
    deleteCustomer () {
      // console.log('Delete customer: ' + this.currentCustomer.name)

      axios.delete('/backend/rest/customer/' + this.currentCustomer.id)
        .then(response => {
          // console.log('Got response: ' + response)

          this.loadCustomers()
        })
        .catch(error => {
          console.log(error.response.data.message)
        })

      this.confirmDeleteDialog = false
      this.currentCustomer = null
    },
    loadSalesOrganizations () {
      // console.log('Loading sales organizations')
      axios.get('/backend/rest/sales_organization')
        .then(response => {
          this.salesOrganizations = response.data
        })
    },
    loadDeliveryAddresses () {
      // console.log('Loading delivery addresses for customer ' + this.currentCustomer.id)
      axios.get('/backend/rest/delivery_address/customer/' + this.currentCustomer.id + '/all')
        .then(response => {
          // console.log('Response data: ' + Object.keys(response))
          this.deliveryAddresses = response.data
          // console.log('Delivery addresses: ' + this.deliveryAddresses)
        })
    },
    selectDeliveryAddress (item) {
      for (let c of this.deliveryAddresses) {
        if (c.id === item.id) {
          this.currentDeliveryAddress = c
          if (this.currentDeliveryAddress.address.latitude === 0) {
            this.currentDeliveryAddress.address.latitude = ''
          }
          if (this.currentDeliveryAddress.address.longitude === 0) {
            this.currentDeliveryAddress.address.longitude = ''
          }
          break
        }
      }
    },
    addDeliveryAddress () {
      this.currentDeliveryAddress = {
        id: 0,
        customerId: this.currentCustomer.id,
        address: {
          street: '',
          houseNo: '',
          location: '',
          zipCode: '',
          city: '',
          country: '',
          latitude: '',
          longitude: ''
        }
      }
      this.$nextTick(() => this.$refs.deliveryAddressStreet.focus())
    },
    saveDeliveryAddress () {
      // console.log('Save the delivery address')
      axios.post('/backend/rest/delivery_address', this.currentDeliveryAddress)
        .then(response => {
          // console.log('Got response: ' + response)
          this.loadCustomers()
          this.loadDeliveryAddresses()
        })
        .catch(error => {
          console.log(error.response.data.message)
        })
      this.currentDeliveryAddress = null
    },
    deleteDeliveryAddress (index) {
      axios.delete('/backend/rest/delivery_address/' + this.currentDeliveryAddress.id)
        .then(response => {
          // console.log('Got response: ' + response)

          this.loadDeliveryAddresses()
        })
        .catch(error => {
          console.log(error.response.data.message)
        })
      this.confirmDeleteDeliveryAddressDialog = false
      this.currentDeliveryAddress = null
    },
    cancelCustomer () {
      // console.log('Cancel the customer')
      this.currentCustomer = null
      this.currentDeliveryAddress = null
      this.loadCustomers()
    },
    cancelDeliveryAddress () {
      // console.log('Cancel the delivery address')
      this.currentDeliveryAddress = null
      this.loadDeliveryAddresses()
    },
    printShipments () {
      let url = '/backend/print/customerShipments.xhtml?customerId=' + this.currentCustomer.id + '&title=Customer shipments' + '&uuid=' + uuid()
      window.open(url)
    },
    exportShipments () {
      let url = '/backend/report/customerShipmentsReport?customerId=' + this.currentCustomer.id + '&uuid=' + uuid()
      window.open(url)
    },
    toggleFilterInactive (inactive) {
      this.filterInactive = inactive
    }
  },
  watch: {
    sessionSalesOrganizations () {
      this.loadCustomers()
    }
  }
}
</script>
<style scoped>
  html {
    overflow-y: auto;
  }
  tr.customerDeliveryAddresses td:not(.action) {
    padding: 0 0 0 15px !important;
  }
  tr.customerDeliveryAddresses td.action {
    padding: 0 8px !important;
  }
  tr.customerDeliveryAddresses td .v-input {
    padding: 0 !important;
  }
  .v-input {
    padding-top: 0;
    margin-top: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Customers.vue